<template>
  <a-card>
    <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
      @change="onTableChange">
      <template #titles="{ record }">
        <a @click="onDetail(record)">
          {{ record.title }}

      </a>
      </template>
      <template #receiveStatus="{ text }">
        <span>{{ text == 1 ? '未读' : '已读' }}</span>
      </template>
    </a-table>
  </a-card>
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @onCloseModel="refresh" />
</template>

<script>
import DetailModal from './components/DetailModal';
import { tableListMixin } from "@/mixins";
import { basicsBaseCompanyNotice } from "@/api/adminService";

const columns = [
  { title: "标题", dataIndex: "title", key: "title", slots: { customRender: "titles" } },
  { title: "时间", dataIndex: "publishTime", key: "publishTime" },
  { title: '状态', dataIndex: 'receiveStatus', key: 'receiveStatus', slots: { customRender: 'receiveStatus' } }
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: { DetailModal },
  data() {
    return {
      columns,
      queryParam: {},
      listUrl: basicsBaseCompanyNotice.pageList,
      listKeyField: "id",
    }
  },
  methods: {
    onDetail(record) {
      this.getAction({
        url: basicsBaseCompanyNotice.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res)
      })
    },
    refresh() {
      this.loadData();
    }
  }
}
</script>

<style scoped></style>
